import ProductsTemplate from './ProductsTemplate'

export default ProductsTemplate
